import React from 'react';
import { Link } from 'react-router-dom';
import PackageCard from './PackageCard';
import './PackagesSection.css';
import membershipImg from '../assets/membershippackage.png';
import ceramicImg from '../assets/ceramicpackage.png';
import grapheneImg from '../assets/graphenepackage.png';
import boropheneImg from '../assets/borophenepackage.png';
import ppfImg from '../assets/ppfpackage.png';

const packagesData = [
  {
    title: 'Automatic Car Wash Membership',
    icon: <img src={membershipImg} alt="Membership" style={{ width: 56, height: 56, objectFit: 'contain' }} />,
    iconBg: 'linear-gradient(90deg, #00516B 0%, #1085AC 100%)',
    gradient: 'linear-gradient(90deg, #00516B 0%, #1085AC 100%)',
    topDetails: 'VALID FOR 2 YEARS | NATIONAL COVERAGE\njoin our exclusive membership program and enjoy consistent savings every time you wash your vehicle.',
    membershipTitle: 'DRIVE-IN CAR SPA MEMBERSHIP',
    membershipDesc: 'Once enrolled, you\'ll receive a Drive-In Car Spa Membership ID that gives you 10% off at any Drive-In location across India with a Premium Plus system.',
    membershipDescColor: '#00516B',
    whatsIncluded: 'What\'s Included',
    features: [
      '2-year membership validity',
      '10–20% discount at all participating outlets',
      'Access to India’s leading automated car spa brand',
      'Zero maintenance effort, maximum savings',
    ],
    audience: 'Regular drivers, fleet owners, and dealership partners',
    cta: 'Contact Us',
    ctaLink: '#',
  },
  {
    title: 'Ceramic Coating Package (With 10 Free Washes)',
    icon: <img src={ceramicImg} alt="Ceramic" style={{ width: 56, height: 56, objectFit: 'contain' }} />,
    iconBg: 'linear-gradient(90deg, #0056d6 0%, #00bfff 100%)',
    gradient: 'linear-gradient(90deg, #0056d6 0%, #00bfff 100%)',
    topDetails: 'GLASS • PROTECTION • PEACE OF MIND\nenhance your vehicle\'s value and protect it from environmental damage with our ceramic coating package.',
    membershipTitle: 'DRIVE-IN CAR SPA MEMBERSHIP',
    membershipDesc: 'This advanced coating adds a transparent, glossy shield that resists dirt, UV, and minor scratches, making it ideal for professional car detailing and long-term protection.',
    membershipDescColor: '#0056d6',
    whatsIncluded: 'What\'s Included',
    features: [
      'Full-body ceramic coating application',
      '10 free automatic car washes',
      'Long-lasting water-repellent finish',
      'Paint protection and enhanced color depth',
    ],
    audience: 'New car owners and those who want long-term shine',
    cta: 'Contact Us',
    ctaLink: '#',
  },
  {
    title: 'Graphene Coating Package (with 10 Free Washes)',
    icon: <img src={grapheneImg} alt="Graphene" style={{ width: 56, height: 56, objectFit: 'contain' }} />,
    iconBg: 'linear-gradient(90deg, #7c3aed 0%, #a084e8 100%)',
    gradient: 'linear-gradient(90deg, #7c3aed 0%, #a084e8 100%)',
    topDetails: 'FUTURE-GRADE PROTECTION FOR YOUR VEHICLE',
    membershipTitle: 'DRIVE-IN CAR SPA MEMBERSHIP',
    membershipDesc: 'Graphene coating is tougher, smoother, and more heat-resistant than traditional ceramic. This next-gen package ensures stronger scratch resistance and less surface heat retention—great for Indian weather conditions.',
    membershipDescColor: '#7c3aed',
    whatsIncluded: 'What\'s Included',
    features: [
      'Full-body graphene coating',
      '10 complimentary automatic washes',
      'Enhanced anti-static and water-repellent effect',
      'UV & swirl mark protection',
    ],
    audience: 'Premium cars and long-term performance seekers',
    cta: 'Contact Us',
    ctaLink: '#',
  },
  {
    title: 'Borophene Coating Package (with 10 Free Washes)',
    icon: <img src={boropheneImg} alt="Borophene" style={{ width: 56, height: 56, objectFit: 'contain' }} />,
    iconBg: 'linear-gradient(90deg, #e91e63 0%, #ff7eb3 100%)',
    gradient: 'linear-gradient(90deg, #e91e63 0%, #ff7eb3 100%)',
    topDetails: 'NANO-ENGINEERED VALUE WITH CUTTING EDGE PROTECTION',
    membershipTitle: 'DRIVE-IN CAR SPA MEMBERSHIP',
    membershipDesc: 'Our borophene coating package offers exceptional nanotechnology defense against weather, oxidation, and everyday wear.',
    membershipDescColor: '#e91e63',
    whatsIncluded: 'What\'s Included',
    features: [
      'Advanced borophene nano-coating',
      '10 free automatic washes',
      'Self-cleaning & scratch-resistant',
      'Long-term finish preservation',
    ],
    audience: 'Tech-lovers, enthusiasts & eco-conscious car owners',
    cta: 'Contact Us',
    ctaLink: '#',
  },
  {
    title: 'Paint Protection Film Package (with 10 Free Washes)',
    icon: <img src={ppfImg} alt="PPF" style={{ width: 56, height: 56, objectFit: 'contain' }} />,
    iconBg: 'linear-gradient(90deg, #388e3c 0%, #a8e063 100%)',
    gradient: 'linear-gradient(90deg, #388e3c 0%, #a8e063 100%)',
    topDetails: 'PRESERVE PERFECTION WITH INVISIBLE PPF',
    membershipTitle: 'DRIVE-IN CAR SPA MEMBERSHIP',
    membershipDesc: 'Protect your vehicle from chips, scratches, and road debris with our premium Paint Protection Film (PPF).',
    membershipDescColor: '#388e3c',
    whatsIncluded: 'What\'s Included',
    features: [
      'Installation of high-grade PPF on key areas',
      '10 free automatic car washes',
      'UV & heat protection',
      'Self-healing from micro-scratches',
    ],
    audience: 'New cars, high-value vehicles & long-distance drivers',
    cta: 'Contact Us',
    ctaLink: '#',
  },
];

const PackagesSection = ({ packages = packagesData }) => (
  <div className="packages-section">
    <div className="packages-section-header container">

      <h2 className="packages-section-title">
        Car Care Packages – <Link to="/" className="link-text">Best Car <br />Detailing packages in Bangalore</Link>
      </h2>

      <div className="packages-section-subtitle">
        Professional Car Detailing & Full car spa service near me
      </div>

      <div className="packages-section-desc">
        At Drive-In Car Spa, we offer premium car detailing services near me designed for convenience, performance, and long-term protection. Whether you need a quick clean or a complete full car spa service near me, our packages are tailored to suit every vehicle type and lifestyle. We ensure no surprises, no hidden costs, and only high-quality professional car detailing services for your vehicle.
      </div>

    </div>

    <div className="packages-grid">
      {packages.map((pkg, idx) => (
        <PackageCard key={idx} {...pkg} />
      ))}
    </div>
  </div>
);

export default PackagesSection;